import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { bool, func, number, oneOfType, string } from 'prop-types';
import { Input, Label } from './radio.styles';

const Radio = _ref => {
  let {
    pointerNone,
    label,
    onChange
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["pointerNone", "label", "onChange"]);

  const input = /*#__PURE__*/React.createElement(Input, _extends({
    pointerNone: pointerNone
  }, props, {
    onChange: onChange,
    "data-testid": "radio-input"
  }));
  return label ? /*#__PURE__*/React.createElement(Label, _extends({}, props, {
    "data-testid": "radio"
  }), input, label) : input;
};

process.env.NODE_ENV !== "production" ? Radio.propTypes = {
  name: string,
  label: string,
  value: oneOfType([string, number]),
  checked: bool,
  fontSize: number,
  onChange: func,
  pointerNone: bool
} : void 0;
Radio.defaultProps = {
  fontSize: 1,
  pointerNone: ''
};
export default Radio;